import React, { useEffect, useState } from "react";
import database from "../service/FirebaseConfig";
import "../assets/Quotes.css"; // Import the custom CSS for styling

const QuotesCard = ({ Quotes }) => {
  return (
    <div className="Quotes-card">
      <h2
        style={{
          width: "300px",
          overflowWrap: "break-word",
          textAlign: "left",
        }}
      >
        {Quotes.quote}
      </h2>
    </div>
  );
};

const Quotes = () => {
  const [Quotes, setQuotes] = useState([]);

  useEffect(() => {
    const QuotesRef = database.ref("Quotes");
    QuotesRef.once("value", (snapshot) => {
      const QuotesData = snapshot.val();
      if (QuotesData) {
        const QuotesList = Object.keys(QuotesData).map((key) => ({
          id: key,
          ...QuotesData[key],
        }));
        setQuotes(QuotesList);
      }
    });
  }, []);

  return (
    <div className="Quotes-container">
      <h1 className="heading">Quotes And Works</h1>
      <div className="Quotes-list">
        {Quotes.map((Quotes) => (
          <QuotesCard key={Quotes.id} Quotes={Quotes} />
        ))}
      </div>
    </div>
  );
};

export default Quotes;
